import { useParams, useLocation } from 'react-router-dom'

export type ViewMode =
  | 'default'
  | 'admin'
  | 'provider'
  | 'clinic'
  | 'clinic_group'
  | 'ad'
  | 'ad_supplier_group'

interface ViewModeResult {
  mode: ViewMode
  id: number | null
}

export function useViewMode(): ViewModeResult {
  const params = useParams()
  const { pathname } = useLocation()

  if (pathname.startsWith('/clinic-group/'))
    return { mode: 'clinic_group', id: toId(params.clinic_group_id) }
  if (pathname.startsWith('/clinic/'))
    return { mode: 'clinic', id: toId(params.clinic_id) }
  if (pathname.startsWith('/ad-supplier-group/'))
    return { mode: 'ad_supplier_group', id: toId(params.ad_supplier_group_id) }
  if (pathname.startsWith('/ad-supplier/'))
    return { mode: 'ad', id: toId(params.supplier_id) }
  if (pathname.startsWith('/provider/'))
    return { mode: 'provider', id: toId(params.provider_id) }
  if (pathname === '/admin' || pathname.startsWith('/admin/'))
    return { mode: 'admin', id: null }

  return { mode: 'default', id: null }
}

function toId(s: string | undefined): number | null {
  if (s === undefined) return null
  const n = Number(s)
  return Number.isFinite(n) && n > 0 ? n : null
}
